interface AgeResult {
    age: string;
    isBirthday: boolean;
    daysUntilBirthday: number | null; // negative = days ago, positive = days until, 0 = today
}

export const calculateAge = (dateOfBirth: string | Date): AgeResult => {
    // Get today in Israel timezone
    const now = new Date();
    const israelFormatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Jerusalem',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const todayParts = israelFormatter.format(now).split('-').map(Number);
    const today = new Date(todayParts[0], todayParts[1] - 1, todayParts[2]);

    // Get birth date in Israel timezone
    const birthDate = new Date(dateOfBirth);
    const birthParts = israelFormatter.format(birthDate).split('-').map(Number);
    const birth = new Date(birthParts[0], birthParts[1] - 1, birthParts[2]);

    let years = today.getFullYear() - birth.getFullYear();
    let months = today.getMonth() - birth.getMonth();

    if (months < 0 || (months === 0 && today.getDate() < birth.getDate())) {
        years--;
        months += 12;
    }
    if (today.getDate() < birth.getDate()) {
        months--;
        if (months < 0) months += 12;
    }

    // Check if birthday is within 7 days (past or future)
    const thisYearBirthday = new Date(today.getFullYear(), birth.getMonth(), birth.getDate());

    const msPerDay = 1000 * 60 * 60 * 24;
    const diffDays = Math.round((thisYearBirthday.getTime() - today.getTime()) / msPerDay);

    let daysUntilBirthday: number | null = null;
    let isBirthday = false;

    // Check if birthday is within 7 days range
    if (diffDays >= -7 && diffDays <= 7) {
        daysUntilBirthday = diffDays;
        isBirthday = true;
    }

    return {
        age: months > 0 ? `${years}.${months}` : `${years}`,
        isBirthday,
        daysUntilBirthday,
    };
};
